import React from 'react';

/**
 * SkipToContent Component
 * Provides a keyboard-accessible link to skip navigation and jump to main content
 * This improves accessibility for keyboard and screen reader users
 */
const SkipToContent = () => {
      return (
            <a
                  href="#main-content"
                  className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:px-4 focus:py-2 focus:bg-blue-600 focus:text-white focus:rounded-md focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
                  Skip to main content
            </a>
      );
};

export default SkipToContent;
